export default __webpack_public_path__ + "static/avatar-aae79ccae59ce7703efbbcd407aae873.jpeg";